// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ga2q","notes":"Notes_notes__1iiR6"};